import { render, staticRenderFns } from "./barsEdades.vue?vue&type=template&id=b335232e&scoped=true"
import script from "./barsEdades.vue?vue&type=script&lang=js"
export * from "./barsEdades.vue?vue&type=script&lang=js"
import style0 from "./barsEdades.vue?vue&type=style&index=0&id=b335232e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b335232e",
  null
  
)

export default component.exports